<!-- <!DOCTYPE html>
<html lang="en"> -->

<!-- <head> -->
<title>Inicio de sesion</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
<!--===============================================================================================-->
<!-- <link href="./assets/login/images/favicon.png" rel="icon"> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/vendor/bootstrap/css/bootstrap.min.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/icons.css" /> -->
<!--===============================================================================================-->
<!-- <link rel="stylesheet" type="text/css" href="./assets/login/css/main.css" /> -->
<!--===============================================================================================-->
<!-- </head> -->

<!-- <body style="background-color: #999999;"> -->
    <dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
<div class="limiter animated fadeIn">
    <div class="container-login100">
        <div class="login100-more" style="background-image: url(&#39;./assets/login/images/bg-01.jpg&#39;);"></div>

        <div class="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50 m-login__wrapper">
            <div class="m-login__logo">
                <a href="#"><img src="./assets/global/images/logo_wtw.svg" style="width: 60%;padding-left: 30%;" /></a>
            </div>

            <form class="login100-form validate-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" validate="off">
                <span class="login100-form-title p-b-59">Ingrese a su cuenta</span>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <div class="input-group-addon"><i class="icon-user"></i>
                    </div><input type="email" class="form-control" id="usuario" formControlName="userName" placeholder="Escribe tu correo electrónico" autocomplete="on" />
                </div>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <div class="input-group-addon"><i class="icon-key"></i></div>
                    <input type="password" class="form-control password" formControlName="password" id="contraseña" placeholder="Ingresa tu contraseña" autocomplete="off" (copy)="$event.preventDefault()" />
                </div>

                <div class="col-md-12 col-sm-12 form-group input-group">
                    <div #recaptcha></div>
                </div>
                <div class="col-md-12 col-sm-12 col m--align-right">
                    <a [routerLink]="['/forgotpass']" id="Olvidó su contraseña" class="m-link">
                        ¿Olvidó su
                        contraseña?
                    </a>

                </div><button [disabled]="!loginForm.valid" type="submit" class="btn login100-form-btn">Ingresar</button>
            </form>
            <div class="col m--align-left copyright">
                ©2018 Willis Towers Watson. Todos los Derechos Reservados.
            </div>
        </div>
    </div>
</div>

<!--===============================================================================================-->
<script src="./assets/login/vendor/jquery/jquery-3.2.1.min.js"></script>
<!--===============================================================================================-->

<script src="./assets/login/vendor/bootstrap/js/popper.js"></script>
<script src="./assets/login/vendor/bootstrap/js/bootstrap.min.js"></script>
<!--===============================================================================================-->
<script src="./assets/login/js/main.js"></script>
<script src="https://www.google.com/recaptcha/api.js?render=6LeDDyYqAAAAAJQHoSdZI8BRXax9ye84bh9xKGrd"></script>

<!-- </body> -->

<!-- </html> -->